<template>
  <v-container fluid class="insights-hub pa-4">
    <div class="d-flex align-center mb-2" style="gap: 12px">
      <span style="font-size: 32px">📊</span>
      <div>
        <h2 class="text-h4 font-weight-bold ma-0 theme-heading">Insights</h2>
        <p class="text-body-2 ma-0 theme-text-secondary">
          Talent intelligence, platform analytics, and movement tracking
        </p>
      </div>
    </div>

    <v-tabs v-model="activeTab" background-color="transparent" color="primary" class="mb-4 mt-4">
      <v-tab>Talent Intelligence</v-tab>
      <v-tab>Analytics</v-tab>
      <v-tab>Movement</v-tab>
    </v-tabs>

    <v-tabs-items v-model="activeTab">
      <v-tab-item>
        <IntelligenceTalentInsights :embedded="true" />
      </v-tab-item>
      <v-tab-item>
        <IntelligenceAnalytics :embedded="true" />
      </v-tab-item>
      <v-tab-item>
        <MovementAnalytics :embedded="true" />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import IntelligenceTalentInsights from "./IntelligenceTalentInsights.vue";
import IntelligenceAnalytics from "./IntelligenceAnalytics.vue";
import MovementAnalytics from "./MovementAnalytics.vue";

const TAB_MAP = {
  intelligence: 0,
  analytics: 1,
  movement: 2,
};

const TAB_NAMES = ["intelligence", "analytics", "movement"];

export default {
  name: "IntelligenceInsightsHub",
  components: {
    IntelligenceTalentInsights,
    IntelligenceAnalytics,
    MovementAnalytics,
  },
  data() {
    return {
      activeTab: 0,
    };
  },
  watch: {
    activeTab(newVal) {
      const tabName = TAB_NAMES[newVal];
      if (tabName && this.$route.query.tab !== tabName) {
        this.$router.replace({ query: { ...this.$route.query, tab: tabName } }).catch(() => {});
      }
    },
    "$route.query.tab"(newTab) {
      if (newTab && TAB_MAP[newTab] !== undefined) {
        this.activeTab = TAB_MAP[newTab];
      }
    },
  },
  created() {
    const tab = this.$route.query.tab;
    if (tab && TAB_MAP[tab] !== undefined) {
      this.activeTab = TAB_MAP[tab];
    }
  },
};
</script>

<style scoped>
.insights-hub {
  max-width: 1400px;
}
</style>
